export default __webpack_public_path__ + "static/media/cake10.2ac788ff.jpg";